module.exports = __webpack_public_path__ + "img/IMG_8946.ee1479b6.jpg";